import * as React from 'react';
import { getIconType } from '../../reducers/results-model';

interface IProps {
    type: string
}

export const MediaIcon: React.FC<IProps> = (props) => {
    const iconName = getIconType(props.type);
    const mediaLogo = '<svg className="search-result-icon icon-Icon_Audio" height="24px" width="24px"><use xlink:href="#' + iconName + '"></use></svg>';

    if (iconName.length <= 0) {
        return null;
    }
    return (
        <div className="search-result-link-icon" dangerouslySetInnerHTML={{ __html: mediaLogo }} />
    );
}